// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoadingBar_loaderContainer__vYUPl"};